import { render, staticRenderFns } from "./CNavbarLogo.vue?vue&type=template&id=982aaa6e&"
import script from "./CNavbarLogo.vue?vue&type=script&lang=js&"
export * from "./CNavbarLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports